import { useContext, useState } from "react";
import Auth0Context from "contexts/Auth0Context";
import useAuth from "hooks/useAuth";
import { enviarDatosAlServidor } from "../../Helper/Post_Json";

// Campos auxiliares que el servidor requiere vacíos/reset en cada submit
const CLEARED_FIELDS = {
  aceptamos_devolucion_name: "",
  codigo_barra_name: "",
  componente_name: "",
  condition_name: "",
  deposito_destino_name: "",
  descripcion_name: "",
  detalle_taller_id: 0,
  estado_sku_name: "",
  estetica_packaging_name: "",
  estetica_producto_name: "",
  falla_name: "",
  fecha_analisis_taller: null,
  id_comentarios: 0,
  id_devoluciones: 0,
  lote_name: "",
  motivo_del_scrap_name: "",
  nombre_estado: "",
  nombre_usuario: "",
  numero_serie_name: "",
  origen_devolucion_name: "",
  reparacion_name: "",
  responsable_name: "",
  row_num: 0,
  sintoma_name: "",
  taller_row_num: 0,
};

// Máquina de transiciones: estado actual → { endpoint, nextState }
const STATE_TRANSITIONS = {
  3: { endpoint: "ServiceOperation/UpdateAdminFin", nextState: 4 },
  4: { endpoint: "ServiceOperation/UpdateAdminFinReAbierto", nextState: 2 },
};
const DEFAULT_TRANSITION = { endpoint: "ServiceOperation/UpdateAdmin" };

const computeNextState = (formData, actionType) => {
  if (actionType === "reopen") return 2;
  if (formData.id_aceptamos_devolucion === 1 && formData.estado <= 2) return 2;
  if (formData.estado === 3) return 4;
  return formData.estado;
};

/**
 * Encapsula toda la lógica de submit del formulario de ticket.
 * @param {object} formData - datos actuales del formulario
 * @param {Function} onSuccess - callback(message, transition) cuando el submit es exitoso
 * @param {Function} onError - callback() cuando hay un error
 */
export function useAdminFormSubmit({ formData, onSuccess, onError }) {
  const { accessToken } = useAuth();
  const { user } = useContext(Auth0Context);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(null);

  const handleSubmit = async (e, actionType) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log(e, "data a enviar");

    const now = new Date().toISOString();
    const transition = STATE_TRANSITIONS[formData.estado] ?? DEFAULT_TRANSITION;
    const nextState = computeNextState(formData, actionType);

    const payload = {
      ...formData,
      ...CLEARED_FIELDS,
      estado: nextState,
      update_timestamp: now,
      fecha_analisis_admin: now,
      userNickname: user.nickname,
    };

    try {
      const result = await enviarDatosAlServidor(
        payload,
        transition.endpoint,
        accessToken,
      );

      if (result?.success) {
        setIsSubmitSuccessful(true);
        onSuccess(result.message, transition);
      } else {
        setIsSubmitSuccessful(false);
        onError();
      }
    } catch {
      setIsSubmitSuccessful(false);
      onError();
    } finally {
      setIsSubmitting(false);
    }
  };

  return { handleSubmit, isSubmitting, isSubmitSuccessful };
}
